export const SETORDERNOLIST = "SETORDERNOLIST";
export const SETFILTERCUSTOMERLIST = "SETFILTERCUSTOMERLIST";
export const SETSALESORDERLIST = "SETSALESORDERLIST";
export const SETPRJLIST = "SETPRJLIST";
export const SETWHSELIST = "SETWHSELIST";
export const SETTAXLIST = "SETTAXLIST";
export const SETCOSTCENTERLIST = "SETCOSTCENTERLIST";
export const SETPAYTERMSLIST = "SETPAYTERMSLIST";
export const SETSUPPLYLIST = "SETSUPPLYLIST";
export const SETSALESEMPLIST = "SETSALESEMPLIST";
export const CLEARDOC = "CLEARDOC";
export const SETITEMLIST = "SETITEMLIST";
export const SETITEMS = "SETITEMS";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETCUSTOMERADDRESS = "SETCUSTOMERADDRESS";
export const SETCUSTOMERADDRESSLIST = "SETCUSTOMERADDRESSLIST";
export const SETSERIESLIST = "SETSERIESLIST";
export const SETHSNLIST = "SETHSNLIST";
export const SETSALESORDER = "SETSALESORDER";
export const SETSALESQUOTE = "SETSALESQUOTE";
export const SETCOPYFROMQUOTELIST = "SETCOPYFROMQUOTELIST";
export const SETATTACHMENTLIST = "SETATTACHMENTLIST";
export const SETADVANCEFILTERLIST = "SETADVANCEFILTERLIST";
export const SETITEMINFO = "SETITEMINFO";
export const SETCUSTOMERINFO = "SETCUSTOMERINFO";
export const SETDUPLICATEDOC = "SETDUPLICATEDOC";
export const SETDEFAULTCURRENCY = "SETDEFAULTCURRENCY";
export const SETKITITEM = "SETKITITEM";
export const SETFLEXIQUOTEDETAILS = "SETFLEXIQUOTEDETAILS";
export const SETSALESORDERBASICFILTERDATA = "SETSALESORDERBASICFILTERDATA";
export const SETEMAILCONTENT = "SETEMAILCONTENT";
export const SETRELATIONSHIPTREE = "SETRELATIONSHIPTREE";
export const SALESORDERBYID = "SALESORDERBYID";
export const SETORDERCATEGORY = "SETORDERCATEGORY";
export const SETPRICELIST = "SETPRICELIST";
export const SETTAXCODE = "SETTAXCODE";
export const SETBPMASTERADDRESS = "SETBPMASTERADDRESS";
export const SETSALESORDERCOUNT = "SETSALESORDERCOUNT";
export const SETSALESORDERITEMLISTING = "SETSALESORDERITEMLISTING";
export const SETATTACHMENTDATA = "SETATTACHMENTDATA";
export const SETPROMOTIONTYPE = "SETPROMOTIONTYPE";
